import httpService from "./httpService";

export default {
  registerCompany: async company => httpService.postAnonymous(`/companyRegistration`, company),
};
